/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

type Props = {
  className: string
}

const TablesWidget10: React.FC<Props> = ({className}) => {
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
            New Quarterly Company Profile Updates
        </h3>
      </div>
      <div className='card-body py-3'>
         <p>
             If you enter quarterly data, you’ll notice a new questionnaire on your to-do list each quarter: the Company Profile Update. 
             Your answers to this brief survey will automatically update your existing Company Management information. Many items in the 
             Company Management section never change, of course, like your date of first grind or your location, but others may change occasionally, 
             like your production volume or your water source. The new Company Profile Update form provides an easy way to ensure all your plant 
             information stays current and accurate. Once you’ve completed the Company Profile Update once, future quarters will display your 
             previous entries so you can simply re-select them if you have no changes. (You can also always see what’s entered for your plant 
             currently by selecting the Company Management tab on the left-hand side of the screen.)
         </p>
          <p>
              We use the Company Management section for two very important functions of our program. First, this is where we get the necessary 
              information to create your <b>customized peer groups</b> (production volume, plant technology, location, and many other factors). Second, 
              we use Company Profile data in researching patterns and trends, to develop a deeper understanding of the “why” behind the numbers, 
              so we can <b>answer your questions and provide more insightful reporting</b>. Thanks for completing the Company Profile Update so we can serve you better!
          </p>
      </div>
    </div>
  )
}

export {TablesWidget10}
